import { render } from "./Questionnaire.vue?vue&type=template&id=00165312&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"

import "./Questionnaire.vue?vue&type=style&index=0&id=00165312&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-00165312"

export default script